import axios, { AxiosResponse } from 'axios';
export interface PromoCode {
  created_at?: string; 
  id?: any;
  code: string;
  code_type: string; 
  code_value: string;
  is_used?: boolean;
  expired_date?: string | null;
  max_count: string
  used_count:string

}

export interface ApplyPromoCodeResponse {
  finalPrice? : any;
  success: boolean;
  promoCode: any,
  message?: string;
  promoCodeId?:any
}


const API_URL = 'https://sodastreamapi.azurewebsites.net/promo-codes';

class PromoCodeService {


  async checkPromoCodeExists(code: string): Promise<{ data: PromoCode | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCode> = await axios.get(`${API_URL}/check-promo-code/${code}`);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error fetching promo code by code promo';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error fetching promo code by code promo:', error);
      return { data: null, error: error.message };
    }
  }


  async createPromoCode(data: PromoCode): Promise<{ data: PromoCode | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCode> = await axios.post(`${API_URL}/`, data);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error creating promo code';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error creating promo code:', error.message);
      return { data: null, error: error.message };
    }
  }



async applyPromoCode({ price, promoCode }: { price: number, promoCode: string }): Promise<{ data: ApplyPromoCodeResponse | null; error: string | null }> {
  try {
   
    const requestBody = { price, promoCode };
    const response: AxiosResponse<ApplyPromoCodeResponse> = await axios.post(`${API_URL}/apply-promo`, requestBody);
    if (response.status >= 200 && response.status < 300) {
      return { data: response.data, error: null };
    } else {
      const error = `Error applying promo code: ${promoCode}`;
      console.error(error);
      return { data: null, error };
    }
  } catch (error: any) {
    console.error('Error applying promo code:', error.message);
    return { data: null, error: error.message };
  }
}

  

  async getAllPromoCodes(): Promise<{ data: PromoCode[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCode[]> = await axios.get(`${API_URL}/`);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error fetching promo codes';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error fetching promo codes:', error);
      return { data: null, error: error.message };
    }
  }


  async getPromoCodeById(id: number): Promise<{ data: PromoCode | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCode> = await axios.get(`${API_URL}/${id}`);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error fetching promo code by ID';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error fetching promo code by ID:', error);
      return { data: null, error: error.message };
    }
  }


  async getPromoCodeByCode(code: string): Promise<{ data: PromoCode | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCode> = await axios.get(`${API_URL}/bycode/${code}`);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error fetching promo code by code';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error fetching promo code by code:', error);
      return { data: null, error: error.message };
    }
  }



  async updatePromoCode(id: number, data: Partial<PromoCode>): Promise<{ data: PromoCode | null; error: string | null }> {
    try {
      const response: AxiosResponse<PromoCode> = await axios.put(`${API_URL}/id/${id}`, data);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = 'Error updating promo code';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error updating promo code:', error.message);
      return { data: null, error: error.message };
    }
  }

  async deletePromoCode(id: number): Promise<{ data: { message?: string } | null; error: string | null }> {
    try {
      const response: AxiosResponse<{ message?: string }> = await axios.delete(`${API_URL}/id/${id}`);
      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = `Error deleting promo code with ID: ${id}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error deleting promo code:', error.message);
      return { data: null, error: error.message };
    }
  }
}

const promoCodeServiceInstance = new PromoCodeService();
export default promoCodeServiceInstance;
